<template>
  <div>
    <div class="global_top">
      <div>
        <div class="logo_wrap">
          <img src="../../assets/common/kepcologo.svg"/>
        </div>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import common from '../../script/common'

export default {
  mounted () {
    common.setCommonCode()
  }
}
</script>

<style scoped>
.global_top {
  display: flex;
  min-width: 1440px;
  height: 64px;
  border-bottom: 1px solid #E4E6E8;
  margin: 0;
  box-sizing: border-box;
}

.global_top > div {
  display: flex;
  width: 1440px;
  margin: 0 auto;
}

.global_top > div > .logo_wrap {
  display: flex;
  width: 200px;
  height: 48px;
  margin: auto 0 auto 10px;
}

.global_top > div > .logo_wrap > img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/join/Join.vue